import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgFestival(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M16.207 6.086l.707.707-2.121 2.121-.707-.707zm-5 2l.707.707-2.121 2.121-.707-.707zm2.243-5.243l.707.707-6.364 6.364-.707-.707zm6.336 2.844c-.123-.066-.73-.422-.466-1.21.091-.271-.213-.575-.482-.484-.392.131-.715.072-.988-.182-.257-.274-.318-.596-.186-.99a.384.384 0 10-.483-.485c-.392.132-.714.072-.973-.168-.269-.275-.334-.603-.2-1.004a.378.378 0 00-.094-.39.38.38 0 00-.388-.094c-.793.266-1.15-.341-1.21-.463a.393.393 0 00-.278-.211.37.37 0 00-.327.1L4.107 9.71a.371.371 0 00-.068.427c.187.384.72.979 1.55.965-.006.443.162.854.497 1.2.332.306.73.46 1.158.453a1.64 1.64 0 00.523 1.225 1.63 1.63 0 001.133.432c-.01.531.231.94.505 1.215.155.155.32.266.458.335.146.07.317.042.429-.069l9.603-9.603a.374.374 0 00.1-.325.388.388 0 00-.209-.278z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Festival')(SvgFestival);
